module.exports = __webpack_public_path__ + "img/growth-1.db5cfe13.svg";